import { Column, Row } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"
import ImgCom from "./ImgCom"
import { ReactComponent as BrowserSvg } from 'assets/svgs/browser_icon.svg'
import { useAppSelector } from "hooks/redux/hooks"
import { shortStr } from "utils"
import { useAccount } from "wagmi"
import { useCallback, useEffect, useState } from "react"
import CopyToClipboard from "react-copy-to-clipboard"
import chainRpcs from "data/chainRpc"

const ReceiveAddressCom = () => {
    const { toAddress, toChain } = useAppSelector((state) => state.coreInfo)
    const { isConnected } = useAppSelector((state) => state.wallet)
    const { address } = useAccount()

    const [isCopy, setIsCopy] = useState(false);
    useEffect(() => {
      if (isCopy) {
        setTimeout(() => {
          setIsCopy(false);
        }, 2000);
      }
    }, [isCopy]);

    const showAddress = useCallback(() => {
        return (toAddress || (isConnected && address))
    }, [toAddress, isConnected, address])

    const fnOpenBrowser = useCallback(() => {
        if(isConnected && toChain) {
            const curAddress = toAddress || address
            const rpcObj = (chainRpcs as any)[toChain.network]
            const openUrl = `${rpcObj['scanUrl']}/address/${curAddress}`
            window.open(openUrl, '_blank')
        }
    }, [address, isConnected, toAddress, toChain])

    return  <ReceiveAddressWrap $justifyContent="space-between">
        <LeftWrap>
            <DesTitleWrap>
                The output assets will be sent to {!showAddress() ? 'the': ''}
            </DesTitleWrap>
            {
                !showAddress()  && <DesTitleWrap>
                    wallet address you will link.
                </DesTitleWrap>
            }
            {
                showAddress()  && <AddressWrap>
                    <StyledContainer $pointer>{shortStr((toAddress || address || ''), 6)}</StyledContainer>
                    <CopyToClipboard text={(toAddress || address || '')}
                        onCopy={() => setIsCopy(true)}
                    >
                        <CopyBtnWrap>{ isCopy ? 'Copied' : 'Copy'}</CopyBtnWrap>
                </CopyToClipboard>
                    
                </AddressWrap>
            }
        </LeftWrap>
        <ImgCom imgUrl="" hoverActive={isConnected} onClick={fnOpenBrowser}>
            <BrowserSvgWrap $active={isConnected}></BrowserSvgWrap>
        </ImgCom>
    </ReceiveAddressWrap>
}

const ReceiveAddressWrap = styled(Row)`
    padding: 10px 0 10px 20px;
    border-left: 1px dashed #B5B7BA;
`

const LeftWrap = styled(Column)`

`

const DesTitleWrap = styled(StyledContainer)`
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    font-family: RoobertRegular;
`

const AddressWrap = styled(Row)`
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    margin-top: 6px;
`

const CopyBtnWrap = styled(Row)`
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    font-family: RoobertRegular;
    color: ${({theme}) => theme.basicPurple};
    padding: 3px 6px;
    border-radius: 4px;
    background-color: #F6F5F4;
    margin-left: 8px;
    cursor: pointer;
`

const BrowserSvgWrap = styled(BrowserSvg)<{$active: boolean}>`
    width: 20px;
    height: 20px;
    ${
        ({$active, theme}) => $active ? css`
            rect, path {
                fill: ${theme.basicBlack}
            }
        `: css`
            rect, path {
                fill:  #B5B7BA;
            }
        `
    }

`

export default ReceiveAddressCom